
<script>
    import FixedHeader from 'vue-fixed-header'
    export default {
        data :() =>{
          return {
              urlPPDB : process.env.VUE_APP_PPDB_ENDPOINT,
          }
        },
        components: {
            FixedHeader
        },
        mounted (){
          // console.log(this.urlPPDB)
        },
        methods: {
            // offcanvas mobilemenu
            mobiletoggleClass(addRemoveClass, className) {
                const el = document.querySelector('#offcanvas-menu');
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            },
        },
    };
</script>
<template>
    <div class="header-area">
        <div class="header-area__desktop header-area__desktop--default">
            <div class="header-info-area">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-12">
                            <div class="header-info-wrapper align-items-center">
                                <div class="mobile-navigation-icon" id="mobile-menu-trigger" @click="mobiletoggleClass('addClass', 'active')">
                                    <i></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <fixed-header>
                <div class="header-navigation-area bg-white">
                    <div class="container">
                        <div class="row align-items-center">
                                <div class="col-lg-4">
                                  <a class="navbar-brand font-weight-bold" href="/">
                                    SMA Negeri Indonesia
                                  </a>
                                </div>
                                <div class="col-lg-8">
                                <div class="header-navigation header-navigation--header-default position-relative">
                                    <div class="header-navigation__nav position-static">
                                        <nav>
                                          <ul class="text-dark">
                                            <li>
                                              <router-link to="/">Home</router-link>
                                            </li>
                                            <li class="has-children has-children--multilevel-submenu">
                                              <a>Profil</a>
                                              <ul class="submenu">
                                                <li>
                                                  <router-link to="/visi-misi">Visi Misi</router-link>
                                                </li>
                                                <li>
                                                  <router-link to="/jajaran">Jajaran</router-link>
                                                </li>
                                              </ul>
                                            </li>
                                            <li>
                                              <router-link to="/berita">Berita</router-link>
                                            </li>
                                            <li>
                                              <router-link to="/galeri">Galeri</router-link>
                                            </li>
                                            <li>
                                              <router-link to="/jurusan">Jurusan</router-link>
                                            </li>
                                            <li>
                                             <a :href="urlPPDB" target="_blank">PPDB</a>
                                            </li>
                                            <li>
                                              <router-link to="/kontak">Kontak</router-link>
                                            </li>
                                          </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fixed-header>
            <!--=======  End of header navigation area =======-->
        </div>
    </div>
    <!--====================  End of header area  ====================-->
</template>
<style lang="scss">
    .vue-fixed-header--isFixed {
        left: 0;
        top: 0;
        width: 100vw;
        z-index: 999;
        position: fixed;
        box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.2);
        animation: 900ms cubic-bezier(0.2, 1, 0.22, 1) 0s normal none 1 running fadeInDown;
    }
</style>